module.exports = __webpack_public_path__ + "img/2.991dd73f.png";